import { memo } from 'react';
import snakeCase from 'lodash.snakecase';

import { extractParamsFromMediaUrl } from '../../lib/mediaApiUrl';

import type { Wws_GifItem } from '../../types/graphql';
import DynamicNextImage from '../NextImage/DynamicNextImage';
import PhotoItemWrapper from './SharedComponents/PhotoItemWrapper';

export interface GifItemProps {
  item: Wws_GifItem;
  className?: string | undefined;
}

function GifItem({ item, className }: GifItemProps) {
  const aspectRatioName = item.aspectRatio?.name || '';

  const landscape = ['4:3', '3:2'].includes(aspectRatioName);

  const { url } = extractParamsFromMediaUrl(item.mediaUrl);

  return (
    <PhotoItemWrapper
      className={className}
      landscape={landscape}
      dataTestId={`${snakeCase(item.type).replace(/_/g, '-')}-${item.id}`}
    >
      <DynamicNextImage src={url || ''} alt={'gif'} />
    </PhotoItemWrapper>
  );
}

export default memo(GifItem);
